<template>
  <div class="videoCourseItem" @click="courseDetailEvent()" ref="videoCourseItem">
    <span class="banner" :style="{ backgroundImage: `url(${getImg(dic.banner, false)})`, height:`${itemHeight}px`}"></span>
    <span class="title">{{dic.title}}</span>
    
    <div class="bottomView">
      <span class="zan browser">
        <img :src="images.eye"/>
        <span class="number">{{ dic.browser_count }}</span>
      </span>
      <span v-if="dic.work_link " class="begin" @click.stop="beginProgram()">开始项目</span>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { Utils } from '@/utils'
import {
  IMG_EYE
} from '@/assets'

import { types as VideoCourseTypes } from '@/store/modules/video_course.js'
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "VideoCourseItem",
  components: {},
  props:{
    dic: {
      type: Object
    },
    tag:{
      type:String,
      default: ''
    }
  },
  data () {
    return {
     itemHeight: 150,
     images:{
       eye: IMG_EYE
     }
     
    };
  },
  computed: {
    
  },

  methods: {
    ...mapActions({
      fetchDetailEvent: VideoCourseTypes.FETCH_DETAIL_VIDEO_COURSE
    }),

    ...Utils,
   courseDetailEvent(){
    this.fetchDetailEvent({pk:this.dic.id, types:this.tag})

     window.open(
        `${this.dic.video}`,
        "_blank"
      );
   },
   beginProgram(){
     if(this.dic.work_link){
        window.open(
          `${this.dic.work_link}`,
          "_blank"
        );
     }
   }
  },
  created () {
  },
  destroyed () {
  },
  mounted () {
    console.log(this.$refs.videoCourseItem.clientWidth);
    this.itemHeight = this.$refs.videoCourseItem.clientWidth * 9 / 16;
  }
};
</script>

<style lang="less" scoped>
.videoCourseItem{
  // width: calc(100% / 3 - 10px);
  // margin-left: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  .banner{
    display: inline-block;
    width: 100%;
    height: 150px;
    background: #F4F3F3;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .title{
    margin-top: 10px;
    color: #333333;
    font-size: 14px;
    margin-bottom: 10px;
    padding-left: 5px;
  }
  .begin{
    background-color: #FF7B00;
    font-size: 13px;
    color: #ffffff;
    width: 70px;
    text-align: center;
    height: 25px;
    line-height: 25px;
    border-radius: 15px;
    cursor: pointer;
  }
  .bottomView{
    display: flex;
    flex-direction: row;
    margin: 10px;
    justify-content: space-between;
    margin-top: 0;
  }
  .zan {
    font-size: 13px;
    color: #999999;
    display: flex;
    flex-direction: row;
    line-height: 20px;
    overflow: hidden;
    height: 20px;
    align-items: center;
    img {
      height: 12px;
      margin-right: 3px;
    }
    .number{
      line-height: 20px;
      overflow: hidden;
      height: 20px;
    }
  }
}

</style>
